jQuery(document).ready(function () {
  slider();
  wowo(jQuery);
  headerMenu();
  swiperSlide();
  selectshow();
  accordion();
  video();
  parallax();
  htmladdClass();

  if (jQuery(".marquee").length > 0) {
    Marquee3k.init({
      selector: 'marquee'
    });
  }

  jQuery('.close-burger').click(function () {
    jQuery('header .header-content').css('margin-top', 0);
    jQuery('.fixed-top').hide(200);
  });

  var dots = jQuery('.dot');
  var dotsAnimationIntervalId;
  var isDotsAnimating = false;
  var animationStartTime;
  var animationDuration = 2000;

  function animateDots(callback) {
    if (isDotsAnimating) {
      return;
    }

    var dotCount = dots.length;
    var index = 0;
    isDotsAnimating = true;
    animationStartTime = Date.now();

    clearInterval(dotsAnimationIntervalId);

    dotsAnimationIntervalId = setInterval(function () {
      dots.removeClass('enlarged');
      dots.eq(index).addClass('enlarged');
      index = (index + 1) % dotCount;

      var currentTime = Date.now();
      var elapsedTime = currentTime - animationStartTime;
      if (elapsedTime >= animationDuration) {
        clearInterval(dotsAnimationIntervalId);
        isDotsAnimating = false;
        dots.removeClass('enlarged');
        if (typeof callback === 'function') {
          callback();
        }
      }
    }, 200);
  }

  var textBoxElements = jQuery('.random-text-box p');
  var textBox2Elements = jQuery('.random-text-box-2 p');
  var mapping = {};
  var hasRemovedFirstElement = false;

  textBoxElements.each(function (index) {
    if (index === 0) return;
    var id1 = this.id;
    var id2 = id1.replace('text', 'text-1');
    mapping[id1] = id2;
  });

  function showRandomMatchedPair() {
    if (isDotsAnimating) {
      return;
    }

    if (!hasRemovedFirstElement) {
      textBoxElements.first().remove();
      textBox2Elements.first().remove();
      hasRemovedFirstElement = true;
    }

    if (Object.keys(mapping).length > 0 && textBox2Elements.length > 0) {
      var randomKey = Object.keys(mapping)[Math.floor(Math.random() * Object.keys(mapping).length)];
      var id1 = randomKey;
      var id2 = mapping[randomKey];

      textBoxElements.hide();
      textBox2Elements.hide();

      jQuery('#' + id1).fadeIn(200);
      textBox2Elements.filter('#' + id2).fadeIn(200);
    }
  }

  jQuery('.slogan').click(function () {
    if (isDotsAnimating) {
      return;
    }

    jQuery(this).addClass('disabled');

    animateDots(function () {
      jQuery('.slogan').removeClass('disabled');
      showRandomMatchedPair();
    });
  });

  jQuery('.search-modal__form').on('submit', function (event) {
    event.preventDefault();
    return false;
  });

  movieplay();
});

document.addEventListener("DOMContentLoaded", function () {
  if (jQuery(".sticky-bar.style-3").length > 0) {
    var textPath = document.querySelector(".text-common textPath");
    var copyPath = document.querySelector(".text-copy textPath");
    var textHtml = textPath.innerHTML;
    for (let i = 0; i < 3; i++) {
      textHtml += textHtml;
    }
    textPath.innerHTML = textHtml;
    copyPath.innerHTML = textHtml;

    var pathLength = document.getElementById("text-path").getTotalLength();
    pathLength = Math.ceil(pathLength);
    var textLength = textPath.getComputedTextLength();
    textLength = Math.ceil(textLength);
    var cent = (textLength / pathLength) * 100;
    cent = Math.ceil(cent);

    var offsetPercentage = 0;
    var copyOffsetPercentage = cent;

    copyPath.setAttribute("startOffset", copyOffsetPercentage + "%");

    function updateTextPosition() {
      offsetPercentage -= 0.05;
      copyOffsetPercentage -= 0.05;
      if (offsetPercentage <= - cent) {
        offsetPercentage = cent;
      }
      if (copyOffsetPercentage <= - cent) {
        copyOffsetPercentage = cent;
      }
      textPath.setAttribute("startOffset", offsetPercentage + "%");
      copyPath.setAttribute("startOffset", copyOffsetPercentage + "%");
      jQuery(window).resize(function () {

      });
      requestAnimationFrame(updateTextPosition);
    }
    updateTextPosition();
  } else {
    console.log(" ");
  }
});

jQuery(window).scroll(function () {
  wowo(jQuery);

  if (jQuery(document).scrollTop() > 60) {
    jQuery('header .header-content').addClass('sticky');
  } else {
    jQuery('header .header-content').removeClass('sticky');
  }

  parallax();
});

jQuery(window).resize(function () {
  slider();
  swiperSlide();
});

function parallax() {
  if (jQuery(window).width() >= 991) {
    var wh = jQuery(window).height();
    var sh = jQuery(window).scrollTop();

    jQuery(".parallax").each(function () {
      var parallax_h = jQuery(this).offset().top;
      var item_h = jQuery(this).outerHeight();
      var parallax_y;
      if (sh > (parallax_h - wh) && sh < parallax_h + item_h) {
        parallax_y = 50 * (sh - (parallax_h - wh)) / (wh + item_h);
      }
      jQuery(this).css('transform', 'translateY(' + parallax_y + '%)');
    });

    jQuery(".parallax-r").each(function () {
      var parallax_h = jQuery(this).offset().top;
      var item_h = jQuery(this).outerHeight();
      var parallax_y;
      if (sh > (parallax_h - wh) && sh < parallax_h + item_h) {
        parallax_y = 50 * ((parallax_h - wh) - sh) / (wh + item_h);
      }
      jQuery(this).css('transform', 'translateY(' + parallax_y + '%)');
    });
  } else {
    jQuery('.parallax').css('transform', 'translateY(0)');
  }
}

function htmladdClass() {
  jQuery('#cart-icon-bubble').on('click', function (e) {
    e.stopPropagation();
    jQuery('html').addClass('overflow-hidden');
  });

  jQuery('.product-form__buttons').on('click', function (e) {
    e.stopPropagation();
    jQuery('html').addClass('overflow-hidden');
  });

  jQuery('body').on('click', '.drawer__close', function (e) {
    jQuery('html').removeClass('overflow-hidden');
  });

  jQuery('.cart-drawer__overlay').on('click', function (e) {
    e.stopPropagation();
    jQuery('html').removeClass('overflow-hidden');
  });

}

function headerMenu() {
  jQuery('.burger').on('click', function (e) {
    if (jQuery(window).width() < 992) {
      jQuery(this).toggleClass('active');
      jQuery('header').toggleClass('active');
      jQuery('html').toggleClass('overflow-hidden');
      jQuery('header .header-mobile-box').toggleClass('active');
      jQuery('header').removeClass('sticky');
    }
  });

  jQuery('.header-mobile-box .menu-item-has-children a').on('click', function (e) {
    var $parentMenuItem = jQuery(this).closest('.header-mobile-box .menu-item-has-children');
    $parentMenuItem.toggleClass('open');
    $parentMenuItem.siblings('.menu-item-has-children').removeClass('open');
  });

  jQuery('.header__icon').on('click', function (e) {
    // e.stopPropagation();
    jQuery('.header__search .search-modal').toggleClass('open');
    jQuery('html').toggleClass('overflow-hidden');
  });

  jQuery('.search-modal .search-modal__content .search-modal__close-button').on('click', function (e) {
    e.stopPropagation();
    jQuery('.header__search .search-modal').removeClass('open');
    jQuery('html').removeClass('overflow-hidden');
  });

  jQuery('body').on('click', function (e) {
    if (!jQuery(e.target).closest('.header__search').length) {
      jQuery('.header__search .search-modal').removeClass('open');
    }
    jQuery('.shop-all-content form').removeClass('active');
    jQuery('.skin-ed-banner-bottom form').removeClass('active');
  });

  if (jQuery('body').hasClass('home')) {
    jQuery('section.banner .bg-img').addClass('after-opacity');
  }

  jQuery('header .menu-item-has-children').on('mouseover', function (e) {
    if (jQuery(window).width() >= 991) {
      jQuery(this).children().siblings('.sub-menu').addClass('is-show');
      jQuery(this).siblings().find('.sub-menu').removeClass('is-show');
      // jQuery('header').addClass('addbg-white');
      jQuery('.header__search .search-modal').removeClass('open');
    }
  })

  jQuery('header .menu-item').not('.menu-item-has-children').on('mouseover', function (e) {
    if (jQuery(window).width() >= 991) {
      jQuery('.sub-menu').removeClass('is-show');
    }
  });

  jQuery('header ').on('mouseleave', function (e) {
    if (jQuery(window).width() >= 991) {
      jQuery('header .sub-menu').removeClass('is-show');
      jQuery('header').removeClass('addbg-white');
    }
  })

  jQuery('header .sub-menu').on('click', function (e) {
    e.stopPropagation();
  })

  jQuery('.shop-all-content .filter-btn-box .btn').click(function () {
    jQuery('.shop-all-content form').addClass('active');
  });

  jQuery('.shop-all-content  .filter-btn-box').on('click', function (e) {
    e.stopPropagation();
  })

  jQuery('.skin-ed-banner .filter-btn-box .btn').click(function () {
    jQuery('.skin-ed-banner form').addClass('active');
  });

  jQuery('.skin-ed-banner  .filter-btn-box ').on('click', function (e) {
    e.stopPropagation();
  })
}

function wowo($) {
  jQuery('html').addClass("show-c");

  setTimeout(function () {
    var wTop = jQuery(window).scrollTop(), wHeight = jQuery(window).height(), wBottom = wTop + wHeight;
    jQuery(".wowo:not(.animated)").each(function () {
      var me = jQuery(this), meTop = me.offset().top, meHeight = me.height(), meBottom = meTop + meHeight,
        limitTop = wTop - meHeight, limitBottom = wBottom + meHeight;
      if (meTop > limitTop && meBottom < limitBottom) {
        me.addClass("animated");
        setTimeout(function () {
          me.removeClass("animated wowo");
        }, 1500);
      }
    })
  }, 100);
}

function slider() {
  if (jQuery('.text-and-slider .slider-right').length > 0) {
    jQuery('.text-and-slider .slider-right:not(".slick-initialized")').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      speed: 500,
      autoplay: false,
      autoplaySpeed: 3000,
      focusOnSelect: true,
      infinite: true,
      draggable: true,
      fade: true,
      prevArrow: jQuery('.text-content-slider .icon-box .icon-arrow-left'),
      nextArrow: jQuery('.text-content-slider .icon-box .icon-arrow-right'),
    });
  }

  if (jQuery('.product-banner .product-img-box').length > 0) {
    jQuery('.product-banner .product-img-box:not(".slick-initialized")').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      pauseOnHover: true,
      pauseOnFocus: true,
      focusOnSelect: true,
      vertical: true,
      verticalSwiping: true,
      asNavFor: '.product-banner .product-slider',
    });
  }


  if (jQuery('.product-banner .product-slider').length > 0) {
    var rev = jQuery('.product-banner .product-slider');
    rev.on('init', function (event, slick, currentSlide) {
      var
        cur = jQuery(slick.$slides[slick.currentSlide]),
        next = cur.next(),
        next2 = cur.next().next(),
        prev = cur.prev(),
        prev2 = cur.prev().prev();
      prev.addClass('slick-sprev');
      next.addClass('slick-snext');
      prev2.addClass('slick-sprev2');
      next2.addClass('slick-snext2');
      cur.removeClass('slick-snext').removeClass('slick-sprev').removeClass('slick-snext2').removeClass('slick-sprev2');
      slick.$prev = prev;
      slick.$next = next;
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      var cur = jQuery(slick.$slides[nextSlide]);
      slick.$prev.removeClass('slick-sprev');
      slick.$next.removeClass('slick-snext');
      slick.$prev.prev().removeClass('slick-sprev2');
      slick.$next.next().removeClass('slick-snext2');
      next = cur.next(), prev = cur.prev();
      prev.addClass('slick-sprev');
      next.addClass('slick-snext');
      prev.prev().addClass('slick-sprev2');
      next.next().addClass('slick-snext2');
      slick.$prev = prev;
      slick.$next = next;
      cur.removeClass('slick-next').removeClass('slick-sprev').removeClass('slick-next2').removeClass('slick-sprev2');
    });
    jQuery('.product-banner .product-slider:not(".slick-initialized")').slick({
      prevArrow: '<button> prev</button>',
      nextArrow: '<button> next</button>',
      infinite: true,
      centerMode: true,
      slidesPerRow: 1,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerPadding: '0',
      swipe: true,
      customPaging: function (slider, i) {
        return '';
      },
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      speed: 500,
      autoplaySpeed: 3000,
      focusOnSelect: true,
      infinite: true,
      draggable: true,
      variableWidth: true,
      asNavFor: '.product-banner .product-img-box',
      prevArrow: jQuery('.text-content-slider .icon-box .icon-arrow-left'),
      nextArrow: jQuery('.text-content-slider .icon-box .icon-arrow-right'),
      responsive: [
        {
          breakpoint: 1200.5,
          settings: {
            dots: true,
          }
        }
      ]
    });
  }

  if (jQuery('.skin-ed-card .content .top-card-item').length > 0) {
    var itemBtns = jQuery('.skin-ed-card .content .top-card-item .item-btn');
    var itemBtnCount = itemBtns.length;
    var zIndex = 1;
    for (var i = 0; i < itemBtnCount; i++) {
      itemBtns.eq(i).attr('style', 'z-index: ' + (zIndex - i));
    }

    jQuery('.skin-ed-card .content .top-card-item:not(".slick-initialized")').slick({
      slidesToShow: 9,
      slidesToScroll: 1,
      arrows: false,
      speed: 800,
      autoplaySpeed: 3000,
      focusOnSelect: true,
      infinite: true,
      draggable: true,
      asNavFor: '.skin-ed-card .content .bottom-card-item',
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 7,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 489,
          settings: {
            slidesToShow: 2,
          }
        },
      ],
      // init: function (slick) {
      //   var itemBtns = jQuery('.item-btn', slick.$slider);
      //   itemBtns.sort(function (a, b) {
      //     var indexA = parseInt(jQuery(a).attr('data-slick-index'), 10);
      //     var indexB = parseInt(jQuery(b).attr('data-slick-index'), 10);
      //     return indexB - indexA;
      //   });

      //   slick.$slider.empty().append(itemBtns);
      //   slick.slickSetOption('slidesToShow', slick.options.slidesToShow);
      //   slick.reInit();
      // }
    });
  }

  if (jQuery('.skin-ed-card .content .bottom-card-item').length > 0) {
    jQuery('.skin-ed-card .content .bottom-card-item:not(".slick-initialized")').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      speed: 500,
      autoplay: false,
      autoplaySpeed: 3000,
      focusOnSelect: true,
      infinite: true,
      draggable: true,
      fade: true,
      adaptiveHeight: true,
      asNavFor: '.skin-ed-card .content .top-card-item',
      prevArrow: jQuery('.control-slider .icon-box .icon-arrow-left'),
      nextArrow: jQuery('.control-slider .icon-box .icon-arrow-right'),
      customPaging: function (slider, j) {
        return j + 1 + "/" + slider.slideCount;
      },
    });
    var num = jQuery('.slick-num');
    var allNum = jQuery('.skin-ed-card .content .bottom-card-item').slick("getSlick").slideCount;
    num.find(".nownum").html("1");
    num.find(".allnum").html(allNum);
    jQuery('.skin-ed-card .content .bottom-card-item')
      .on("init reInit beforeChange", function (event, slick, currentSlide, nextSlide) {
        var nownum = nextSlide + 1;
        num.find(".nownum").html(nownum);
        jQuery(this).removeClass("move");
        setTimeout(function () {
          jQuery(this).addClass("move");
        }, 400);
      });
  }

  var swiper2 = new Swiper(".mySwiper2", {
    loop: true,
    slidesPerView: 6,
    direction: "vertical",
    freeMode: true,
    watchSlidesProgress: true,
  });
  var swiper3 = new Swiper(".mySwiper3", {
    // grabCursor: true,
    // effect: "cards",
    // coverflowEffect: {
    //   rotate: 50,
    //   stretch: 0,
    //   depth: 100,
    //   modifier: 1,
    //   slideShadows : true,
    // },
    // spaceBetween: 30,

    pagination: '.swiper-pagination',
    paginationClickable: true,
    effect: 'coverflow',
    loop: true,
    centeredSlides: true,
    slidesPerView: 'auto',
    coverflow: {
      rotate: 0,
      stretch: 100,
      depth: 150,
      modifier: 1.5,
      slideShadows: false,
    }
  });
}

function selectshow() {
  jQuery('.tabbed-content .btn-choose .btn-text').on('click', function (e) {
    var secondpage = jQuery(this).index();
    jQuery('.tabbed-content .tabbed-content-content-show .show').eq(secondpage).fadeIn(500).siblings().hide();
  })

  jQuery('.tabbed-content .btn-choose .btn-text').on('click', function (e) {
    e.preventDefault();
    jQuery(this).addClass('active').siblings().removeClass('active');
  })

  jQuery('.skin-ed-card .item-content.style-light-yellow .btn-choose .btn-text').on('click', function (e) {
    var secondpage = jQuery(this).index();
    jQuery('.skin-ed-card .item-content.style-light-yellow .table-show .show').eq(secondpage).fadeIn(500).siblings().hide();
  })

  jQuery('.skin-ed-card .item-content.style-light-yellow .btn-choose .btn-text').on('click', function (e) {
    e.preventDefault();
    jQuery(this).addClass('active').siblings().removeClass('active');
  })

  jQuery('.skin-ed-card .item-content.style-purple .btn-choose .btn-text').on('click', function (e) {
    var secondpage = jQuery(this).index();
    jQuery('.skin-ed-card .item-content.style-purple .table-show .show').eq(secondpage).fadeIn(500).siblings().hide();
  })

  jQuery('.skin-ed-card .item-content.style-purple .btn-choose .btn-text').on('click', function (e) {
    e.preventDefault();
    jQuery(this).addClass('active').siblings().removeClass('active');
  })

  jQuery('.skin-ed-card .item-content.style-light-blue .btn-choose .btn-text').on('click', function (e) {
    var secondpage = jQuery(this).index();
    jQuery('.skin-ed-card .item-content.style-light-blue .table-show .show').eq(secondpage).fadeIn(500).siblings().hide();
  })

  jQuery('.skin-ed-card .item-content.style-light-blue .btn-choose .btn-text').on('click', function (e) {
    e.preventDefault();
    jQuery(this).addClass('active').siblings().removeClass('active');
  })

  jQuery('.skin-ed-card .item-content.style-brown .btn-choose .btn-text').on('click', function (e) {
    var secondpage = jQuery(this).index();
    jQuery('.skin-ed-card .item-content.style-brown .table-show .show').eq(secondpage).fadeIn(500).siblings().hide();
  })

  jQuery('.skin-ed-card .item-content.style-brown .btn-choose .btn-text').on('click', function (e) {
    e.preventDefault();
    jQuery(this).addClass('active').siblings().removeClass('active');
  })

  jQuery('.skin-ed-card .item-content.style-light-purple .btn-choose .btn-text').on('click', function (e) {
    var secondpage = jQuery(this).index();
    jQuery('.skin-ed-card .item-content.style-light-purple .table-show .show').eq(secondpage).fadeIn(500).siblings().hide();
  })

  jQuery('.skin-ed-card .item-content.style-light-purple .btn-choose .btn-text').on('click', function (e) {
    e.preventDefault();
    jQuery(this).addClass('active').siblings().removeClass('active');
  })

  jQuery('.skin-ed-card .item-content.style-blue .btn-choose .btn-text').on('click', function (e) {
    var secondpage = jQuery(this).index();
    jQuery('.skin-ed-card .item-content.style-blue .table-show .show').eq(secondpage).fadeIn(500).siblings().hide();
  })

  jQuery('.skin-ed-card .item-content.style-blue .btn-choose .btn-text').on('click', function (e) {
    e.preventDefault();
    jQuery(this).addClass('active').siblings().removeClass('active');
  })

  jQuery('.skin-ed-card .item-content.style-yellow .btn-choose .btn-text').on('click', function (e) {
    var secondpage = jQuery(this).index();
    jQuery('.skin-ed-card .item-content.style-yellow .table-show .show').eq(secondpage).fadeIn(500).siblings().hide();
  })

  jQuery('.skin-ed-card .item-content.style-yellow .btn-choose .btn-text').on('click', function (e) {
    e.preventDefault();
    jQuery(this).addClass('active').siblings().removeClass('active');
  })

  jQuery('.skin-ed-card .item-content.style-white .btn-choose .btn-text').on('click', function (e) {
    var secondpage = jQuery(this).index();
    jQuery('.skin-ed-card .item-content.style-white .table-show .show').eq(secondpage).fadeIn(500).siblings().hide();
  })

  jQuery('.skin-ed-card .item-content.style-white .btn-choose .btn-text').on('click', function (e) {
    e.preventDefault();
    jQuery(this).addClass('active').siblings().removeClass('active');
  })
}

function accordion() {
  jQuery('.tabbed-content-content-show .accordion-content .item .item-head').on('click', function (e) {
    jQuery(this).toggleClass('active');
    jQuery(this).siblings().slideToggle(300);
    jQuery(this).parents().siblings().find('.item-body').slideUp(300);
    jQuery(this).parents().siblings().find('.item-head').removeClass('active');
  })

  jQuery('.mobile-accordion .accordion-content .item .item-head').on('click', function (e) {
    jQuery(this).toggleClass('active');
    jQuery(this).siblings().slideToggle(300);
    jQuery(this).parents().siblings().find('.item-body').slideUp(300);
    jQuery(this).parents().siblings().find('.item-head').removeClass('active');
  })

  jQuery('.skin-ed-card .right-content .accordion-content .item .item-head').on('click', function (e) {
    jQuery(this).toggleClass('active');
    jQuery(this).siblings().slideToggle(300);
    jQuery(this).parents().siblings().find('.item-body').slideUp(300);
    jQuery(this).parents().siblings().find('.item-head').removeClass('active');
  })

  jQuery('footer .footer-top li > a').on('click', function (e) {
    if (jQuery(window).width() < 769) {
      const $parent = jQuery(this).parent();
      if ($parent.find('.sub-menu-box').length > 0) {
        if ($parent.hasClass('active')) {
          $parent.removeClass('active').find('.sub-menu-box').slideUp(300);
        } else {
          $parent.addClass('active').siblings().removeClass('active').find('.sub-menu-box').slideUp(300);
          $parent.find('.sub-menu-box').slideDown(300);
        }
        e.stopPropagation();
        e.preventDefault();
      }
    }
})
}

function swiperSlide() {
  var isMobile = window.innerWidth <= 577;

  var mySwiper = new Swiper('.swiper-container', {
    slidesPerView: 'auto',
    grabCursor: true,
    pagination: {
      el: '.slick-dots',
    },
    scrollbar: {
      el: '.scrollbar',
      draggable: true,
    },
    centeredSlides: isMobile,
    initialSlide: isMobile ? 1 : 0,
  });
}

function movieplay() {
  if (jQuery('.media-box').length > 0) {
    var video = document.getElementById("myVideo");

    jQuery("#myVideo,#pauseBtn").on("click", function () {
      if (video.paused) {
        video.play();
        jQuery('#pauseBtn').addClass("play");
      } else {
        video.pause();
        jQuery('#pauseBtn').removeClass("play");
      }
    });

    video.addEventListener('ended', function () {
      jQuery('#pauseBtn').removeClass("play");
    });
  }
}

function video() {
  var videoElements = document.querySelectorAll('video');
  videoElements.forEach(function (videoElement) {
    var videoSrc = videoElement.getAttribute('src');
    if (videoSrc && videoSrc.endsWith('.mp4')) {
    } else {
      var hls = new Hls();
      hls.loadSource(videoSrc);
      hls.attachMedia(videoElement);
    }
  });
}

function isEmail(email) {
  var reg = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/;
  if (reg.test(email)) {
    return true;
  } else {
    return false;
  }
}

function appHeight() {
  const doc = document.documentElement;
  doc.style.setProperty('--vh', (window.innerHeight * .01) + 'px');
}

window.addEventListener('resize', appHeight);
appHeight();